import {create} from 'zustand/react';
import type {Boroughs, CenterVideoCallInfo} from '../pages/video_call/types';
import callApi from '../apis/callApi.ts';

export type TVideoCallPageType = 'list' | 'detail';

interface IuseVideoCallStore {
    boroughs: Array<Boroughs>;
    setBoroughs: (val: Array<Boroughs>) => void;
    currentPage: TVideoCallPageType;
    setCurrentPage: (val: TVideoCallPageType) => void;
    selectedBoroughs: Boroughs | null;
    handleRowClick: (val: Boroughs) => void;
    handleBackToList: () => void;
    selectedCenterVideoCallInfoAry: Array<CenterVideoCallInfo>;
    setCenterVideoCallInfo: (val: CenterVideoCallInfo) => void;
    isCalling: boolean;
    setIsCalling: (val: boolean) => void;
    roomName: string;
    setRoomName: (val: string) => void;
    videoCallToken: string;
    setVideoCallToken: (val: string) => void;
    setTokenByRoomName: (centerName: string) => Promise<void>;
}

const useVideoCallStore = create<IuseVideoCallStore>((set, get) => ({
    boroughs: [],
    setBoroughs: (val: Array<Boroughs>) => {
        set({boroughs: val});
    },
    currentPage: 'list',
    setCurrentPage: (val: TVideoCallPageType) => {
        set({currentPage: val});
    },
    selectedBoroughs: null,
    handleRowClick: (val: Boroughs) => {
        set({selectedBoroughs: val});
        set({currentPage: 'detail'});
    },
    handleBackToList: () => {
        set({currentPage: 'list'});
        set({selectedBoroughs: null});
    },
    selectedCenterVideoCallInfoAry: [],
    setCenterVideoCallInfo: (val: CenterVideoCallInfo) => {
        const currentSelected = get().selectedCenterVideoCallInfoAry;
        const existingIndex = currentSelected.findIndex((item) => item.id === val.id);
        if (existingIndex !== -1) {
            set({
                selectedCenterVideoCallInfoAry: [
                    ...currentSelected.slice(0, existingIndex),
                    ...currentSelected.slice(existingIndex + 1),
                ],
            });
        } else {
            set({
                selectedCenterVideoCallInfoAry: [...currentSelected, val],
            });
        }
    },
    isCalling: false,
    setIsCalling: (val: boolean) => {
        set({isCalling: val});
    },
    roomName: '',
    setRoomName: (val: string) => {
        set({roomName: val});
    },
    videoCallToken: '',
    setVideoCallToken: (val: string) => {
        set({videoCallToken: val});
    },
    setTokenByRoomName: async (centerName: string) => {
        const {data} = await callApi().post(`jitsi/token/`, {user: centerName});
        set({videoCallToken: data.token.slice(2, -1)});
    },
}));

export default useVideoCallStore;
